import { useContext, useEffect, useRef } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { isStripeRedirectResponse } from '@/types/guards';
import { ProviderEnum } from '@/types/common';
import type { StripePaymentResponse } from '@/types/payment';

export const StripeCard3DSForm = () => {
  const {
    threeDSSecurityState: { params, handlePaymentSuccess, handlePaymentError },
    stripe,
  } = useContext(CheckoutContext);
  const isProcessing = useRef(false);

  useEffect(() => {
    if (!params || !isStripeRedirectResponse(params, ProviderEnum.STRIPE) || !stripe) {
      return;
    }

    if (isProcessing.current) {
      return;
    }

    isProcessing.current = true;

    stripe
      .handleNextAction({
        clientSecret: (params as StripePaymentResponse).stripe.clientSecret,
      })
      .then((result) => {
        if (result.error) {
          handlePaymentError?.();
        } else {
          handlePaymentSuccess?.();
        }
      })
      .catch((error) => {
        console.error('Stripe handleNextAction error:', error);
        handlePaymentError?.();
      })
      .finally(() => {
        isProcessing.current = false;
      });
  }, [params, handlePaymentSuccess, handlePaymentError, stripe]);
  return null;
};
